"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconBox = exports.StyledCategoryInfoContainer = exports.StyledDescription = exports.StyledValueAlias = exports.StyledOption = exports.StyledPopupInsideContainer = exports.StyledPopupContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _const = require("../../const");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledPopupContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledPopupContainer",
  componentId: "hz8v7c-0"
})(["*{box-sizing:border-box;}position:absolute;box-sizing:border-box;height:auto;min-width:200px;max-width:400px;z-index:2;bottom:40px;left:50%;margin-left:-100px;", ""], function (props) {
  return props.align === _const.ALIGN_VERTICAL && (0, _styledComponents.css)(["padding-left:20px;left:75px;bottom:initial;top:-30px;margin-left:initial;"]);
});

exports.StyledPopupContainer = StyledPopupContainer;

var StyledPopupInsideContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledPopupInsideContainer",
  componentId: "hz8v7c-1"
})(["padding:20px;max-height:200px;overflow-y:auto;border:1px solid rgba(26,28,34,0.1);border-radius:4px;background-color:#ffffff;box-shadow:0 20px 30px 0 rgba(0,0,0,0.1);cursor:initial;", "::-webkit-scrollbar{width:7px;}::-webkit-scrollbar-track{box-shadow:inset 0 0 2px grey;border-radius:10px;background:rgba(0,0,0,0.05);}::-webkit-scrollbar-thumb{background:rgba(0,0,0,0.3);border-radius:10px;}::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,0.4);}&:after{content:\"\";position:absolute;left:calc(50% - 5px);bottom:-20px;border:12px solid transparent;border-top:12px solid #ffffff;z-index:3;", "}"], function (props) {
  return props.align === _const.ALIGN_VERTICAL && (0, _styledComponents.css)(["box-shadow:-10px -10px 30px 0 rgba(0,0,0,0.15);"]);
}, function (props) {
  return props.align === _const.ALIGN_VERTICAL && (0, _styledComponents.css)(["transform:rotate(90deg);left:0;top:5px;bottom:initial;"]);
});

exports.StyledPopupInsideContainer = StyledPopupInsideContainer;

var StyledOption = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledOption",
  componentId: "hz8v7c-2"
})(["position:relative;padding-left:20px;margin-top:0;display:flex;flex-flow:column;justify-content:space-between;margin-bottom:10px;&:last-child{margin-bottom:0;}color:", ";", " font-size:16px;line-height:25px;cursor:pointer;&:hover{color:#c32d7b;}"], function (props) {
  return props.active ? "#2C75B0" : "#393F44";
}, function (props) {
  return props.nonSelectedCategory && (0, _styledComponents.css)(["margin-bottom:5px;"]);
});

exports.StyledOption = StyledOption;

var StyledValueAlias = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledValueAlias",
  componentId: "hz8v7c-3"
})(["position:relative;padding-left:20px;margin-top:10px;margin-bottom:10px;color:#393f44;font-size:16px;line-height:25px;min-height:25px;white-space:nowrap;max-width:200px;overflow:hidden;text-overflow:ellipsis;"]);

exports.StyledValueAlias = StyledValueAlias;

var StyledDescription = _styledComponents["default"].p.withConfig({
  displayName: "style__StyledDescription",
  componentId: "hz8v7c-4"
})(["min-width:240px;font-size:16px;color:#717171;font-style:italic;"]);

exports.StyledDescription = StyledDescription;

var StyledCategoryInfoContainer = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledCategoryInfoContainer",
  componentId: "hz8v7c-5"
})(["display:flex;flex-flow:row;justify-content:space-between;align-items:center;"]);

exports.StyledCategoryInfoContainer = StyledCategoryInfoContainer;

var IconBox = _styledComponents["default"].div.withConfig({
  displayName: "style__IconBox",
  componentId: "hz8v7c-6"
})(["color:#393f44;position:absolute;left:0;top:1px;"]);

exports.IconBox = IconBox;